import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // CLEAN IMPORT - No file extension needed!
import reportWebVitals from './reportWebVitals';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<React.StrictMode>
<App />
</React.StrictMode>
);
reportWebVitals();